import {
  useWSModal,
  useWSSnackbar,
  WSActions,
  WSAlert,
  WSText
} from "@wingspanhq/fe-component-library";
import { Engagement } from "@wingspanhq/wingspan-api-sdk";
import { WSErrorMessage } from "../../../components/WSErrorMessage/WSErrorMessage";
import React from "react";
import { ErrorContextKey } from "../../../services/platform";
import { ActionEngagementDetails } from "../components/ActionEngagementDetails";
import { queriesEngagements } from "@query";

export interface DeleteEngagementTypeModalProps {
  engagement: Engagement;
  onSuccess: (engagement: Engagement) => void;
  onClose: () => void;
}

export const DeleteEngagementTypeModal: React.FC<
  DeleteEngagementTypeModalProps
> = ({ engagement, onClose, onSuccess }) => {
  const { openSnackbar } = useWSSnackbar();
  const [deleteEngagementType, deleteEngagementTypeMeta] =
    queriesEngagements.deleteEngagement.useMutation();

  const handleDelete = async () => {
    await deleteEngagementType({ engagementId: engagement.id! });

    openSnackbar({
      theme: "dark",
      type: "success",
      message: "Engagement deleted"
    });
    onSuccess(engagement);
    onClose();
  };

  return (
    <>
      <WSText.ParagraphSm mb="L" weight="book">
        Are you sure you want to delete this engagement?
      </WSText.ParagraphSm>
      <ActionEngagementDetails engagement={engagement} />

      <WSAlert
        my="2XL"
        theme="warning"
        icon="alert"
        size="M"
        title="Deleting engagement"
      >
        Deletion is a permanent action, it cannot be restored.
      </WSAlert>

      <WSErrorMessage
        error={deleteEngagementTypeMeta.error}
        mb="XL"
        contextKey={ErrorContextKey.Engagement}
      />

      <WSActions
        alignment="fill"
        sortButtons={false}
        buttons={[
          {
            label: "Cancel",
            onClick: onClose,
            kind: "Secondary"
          },
          {
            label: "Delete engagement",
            loading: deleteEngagementTypeMeta.isLoading,
            onAsyncClick: handleDelete,
            kind: "Primary",
            destructive: true
          }
        ]}
      />
    </>
  );
};

export const useDeleteEngagementTypeModal = () => {
  return useWSModal(DeleteEngagementTypeModal, {
    title: "Delete engagement",
    size: "M"
  });
};
